import { Model } from "@vuex-orm/core";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import Batch from "./Batch";
import RawMaterial from "./RawMaterial";

export default class Location extends Model {
  static entity = 'locations';

  // API
  static $fetch() {
    return this.api().get('Locations/')
  }
  static $put (id, data) {
    return this.api().put(`Locations/${id}/`, data)
  }
  static $post (data) {
    return this.api().post(`Locations/`, data)
  }

  static fields() {
    return {
      id: this.attr(null),
      name: this.string(""),
      icon: this.string("fas fa-map-marker-alt"),
      label: this.string("Location"),
      color: this.string("indigo darken-3"),
      counter: this.number(48),
      hint: this.string("The name of your storage location...such as Shelf #8"),
      batches: this.hasMany(Batch, "location_id"),
      rawmaterials: this.hasMany(RawMaterial, "location_id")

    };
  }
  static get validations() {
    return {
      formdata: {
        name: { required, minLength: minLength(1), maxLength: maxLength(48) }
      }
    };
  }
  toCreatePayload() {
    return {
      name: this.name
    };
  }
  toUpdatePayload() {
    return {
      ...this.toCreatePayload(),
      id: this.$id
    };
  }
}

